<template>
  <div class="capital-detail">
    <div class="head-box">
      <div class="banner">
        <div class="text-box">
          <div class="tips">收入累计(元)</div>
          <div class="number">{{moneyData.total || 0}}</div>
        </div>
      </div>
    </div>
    <div class="card-box">
      <div class="head">
        <div class="left">
          <div class="line"></div>
          <span class="text">筛选金额</span>
          <span class="number">{{moneyData.filterTotal || 0}}</span>
        </div>
        <div class="right" @click="chooseTime">
          <span>{{time}}</span>
          <van-icon class="icon" color="#999999" name="play" />
        </div>
      </div>
      <van-list
        ref="vanListRef"
        class="list-box"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="row" v-for="(item,index) in list" :key="index">
          <div class="row-left">
            <div class="top">{{item.sourceTypeString}}</div>
            <div class="bottom">{{item.updatedTime}}</div>
          </div>
          <div class="row-right">{{item.arrivalAmount}}</div>
        </div>
      </van-list>
    </div>
    <van-popup position="bottom" v-model="isTimePop">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择完整时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      isTimePop: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      time: moment().format('YYYY-MM-DD HH:mm'),

      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      list: [],
      moneyData: {
        filterTotal: 0,
        total: 0,
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    init() {
      this.list = [],
      this.pageNum= 1,
      this.finished = false;
      this.loading = true
      this.onLoad()
    },
    chooseTime() {
      this.isTimePop = true
    },
    confirm(time) {
      this.time = moment(time).format('YYYY-MM-DD hh:mm')
      this.isTimePop = false
      this.init()
    },
    cancel() {
      this.isTimePop = false
    },
    onLoad() {
      this.$api.withdrawal.queryMerchantInList({
        filterData: {
          cusId: this.userInfo.customerId,
          startTime: this.time
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res.success) {
            this.moneyData = {filterTotal: res.data.filterTotal,total:res.data.filterTotal}
            this.pageNum++
            this.list.push(...res.data.pageInfo.list)
            this.loading = false;
            this.finished = res.data.pageInfo.isLastPage
          }
        })
    },
  }
}
</script>

<style lang="stylus" scoped>
  .head-box {
    width: 375px;
    height: 315px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/32/EB/rB8LrmXxb3eAS8taAAHAyco-RGc455.png');
    background-size: 100% 100%;
    overflow: hidden;
    .banner {
      width: 343px;
      height: 155px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/32/EB/rB8LrmXxcCGAWAkQAAF6Kz8LCt0188.png');
      background-size: 100% 100%;
      margin: auto;
      margin-top: 18px;
      overflow: hidden;
      .text-box {
        color: #FFFFFF;
        margin: 30px 0 0 20px;
        .tips {
          font-weight: 400;
          font-size: 18px;
        }
        .number {
          font-weight: bold;
          font-size: 28px;
          margin-top: 10px;
        }
      }
    }
  }
  .card-box {
    position: fixed;
    top: 136px;
    width: 100%;
    height: calc(100vh - 136px);
    box-shadow: 1px 3px 11px 1px rgba(187,187,187,0.4);
    border-radius: 17px 17px 0px 0px;
    // height: calc(100vh - 130px);
    // overflow-y: auto;
    background: #fff;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      box-sizing: border-box;
      .left {
        display: flex;
        align-items: center;
        .line {
          width: 4px;
          height: 16px;
          background: #FF6D59;
          border-radius: 2px; 
          margin-bottom: 2px;
        }
        .text {
          color: #000;
          font-size: 16px;
          font-weight: 500;
          margin: 0 6px;
        }
        .number {
          color: #FF6F59;
          font-size: 20px;
          font-weight: bold;
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px;
        box-sizing: border-box;
        width: 158px;
        height: 27px;
        color: #333333;
        font-size: 15px;
        background: #F0F0F0;
        border-radius: 3px;
        .icon {
          width: 20px;
          margin-top: 4px;
          transform: rotate(90deg)
        }
      }
    }
    .list-box {
      padding-left: 16px;
      height: calc(100vh - 196px);
      overflow-y: auto;
      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 10px;
        border-bottom: 1px solid #E5E5E5;
        .row-left {
          .top {
            color: #333333;
            font-size: 16px;
          }
          .bottom {
            color: #999999;
            font-size: 13px;
            margin-top: 10px;
          }
        }
        .row-right {
          color: #333333;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  }
</style>